export default __webpack_public_path__ + "static/media/feature7.0260622b.png";